<template>
  <div>
    <b-modal
      id="modal-telat"
      centered
      title="Update Status Absensi Karyawan"
      header-bg-variant="warning"
      header-text-variant="light"
      @show="showModal()"
    >
      <b-form v-if="dataEdit">
        <b-form-group label="Karyawan" label-cols-md="3">
          <b-form-input v-model="data.namaKaryawan" disabled />
        </b-form-group>

        <b-form-group label="Tanggal" label-cols-md="3">
          <date-picker
            :placeholder="Absenadates(dataEdit)"
            disabled
            style="width: 100%"
          ></date-picker>
        </b-form-group>

        <b-form-group label="Status Absen" label-cols-md="3">
          <b-form-select
            v-model="dataEdit.statusIjin"
            :options="status2"
          ></b-form-select>
        </b-form-group>
        <b-form-group label="Absen Masuk" label-cols-md="3">
          <b-form-select
            v-model="absenMasuk"
            :options="status"
            @input="inputAbsenMasuk"
            :disabled="dataEdit && dataEdit.terlambat == 0"
          ></b-form-select>
        </b-form-group>
        <b-form-group label="Terlambat" label-cols-md="3">
          <b-form-input
            v-model="dataEdit.terlambat"
            @input="inputTerlambat"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Keterangan" label-cols-md="3">
          <b-form-textarea v-model="dataEdit.catatan" />
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-telat')">
          Batal
        </b-button>
        <b-button variant="primary" @click="simpan()">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "modalInput",
  props: ["data", "dataEdit"],
  data() {
    return {
      button: "Simpan",
      busy: false,
      listKaryawan: [],
      shift: [],
      status: [
        { value: 0, text: "Tepat Waktu" },
        { value: 1, text: "Terlambat" },
        // { value: 2, text: "Ijin Terlambat" },
      ],
      status2: [
        { value: 0, text: "Berangkat" },
        { value: 1, text: "Cuti" },
        { value: 2, text: "Dinas" },
        { value: 3, text: "Cuti Hamil" },
        { value: 4, text: "Ijin" },
        { value: 5, text: "Sakit" },
        { value: 6, text: "Alpha" },
        { value: 7, text: "Ijin Keluarga Meninggal" },
        { value: 8, text: "Cuti Istri Melahirkan" },
        { value: 9, text: "Cuti Menikah" },
        { value: 10, text: "Ijin Jatah Libur" },
      ],
      absenMasuk: 0,
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mounted() {
    this.getKaryawan();
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    showModal(){
      const vm = this
      vm.absenMasuk = vm.dataEdit.terlambat ? 1 : 0
    },
    inputAbsenMasuk(x){
      const vm = this
      if(!x){
        vm.dataEdit.terlambat = 0
      }
    },
    inputTerlambat(x){
      const vm = this
      vm.absenMasuk = x == 0 ? 0 : 1
    },
    Absenadates(x) {
      if (x) {
        return this.$moment(this.dataEdit.tanggalAbsen).format("LL");
      } else {
        return "";
      }
    },
    async getKaryawan() {
      let vm = this;

      let shift = await vm.$axios.post("masterShift/list");
      // console.log(shift.data.data, "shift");
      vm.shift = shift.data.data.map((item) => {
        return { value: item.id, text: item.kategoriShift };
      });
    },

    simpan() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.$axios
        .post("absensiKaryawanMobile/updateStatusTerlambat", {
          ...vm.dataEdit,
          id: vm.dataEdit.absensiKaryawanMobileId,
        })
        .then((res) => {
          console.log(res.data.message);
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL INPUT DATA ABSEN KARYAWAN",
              showing: true,
            });
            vm.$bvModal.hide("modal-telat");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: err.message,
            showing: true,
          });
          // vm.$bvModal.hide("modal-input");
        });
    },
  },
};
</script>
